import { render, staticRenderFns } from "./BaseAvatarImageUploader.vue?vue&type=template&id=6d60c38a&scoped=true&"
import script from "./BaseAvatarImageUploader.vue?vue&type=script&lang=js&"
export * from "./BaseAvatarImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./BaseAvatarImageUploader.vue?vue&type=style&index=0&id=6d60c38a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../log-in-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d60c38a",
  null
  
)

export default component.exports